import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

export default function GetStarted() {

    const navigate = useNavigate();

    // const GET_STARTED_HOOK = process.env.GET_STARTED_HOOK;
    // const GET_STARTED_HOOK = 'https://admin.nectrstudio.com/flows/trigger/6670a422-59e8-4a27-90ca-e3d1a3118eac';
    // const CONTACT_SUBMISSION = 'https://admin.nectrstudio.com/items/contact_submissions';
    const GET_STARTED_HOOK = 'https://admin.nectrstudio.com/items/get_started';
    // const CONTACT_SUBMISSION = 'http://localhost:8055/items/Contact_Submissions';


    const [showModal, setShowModal] = useState(false);

    const [form, setForm] = useState({
        businessName: "",
        contactName: "",
        email: "",
        phone: "",
        website: "",
        venueType: "",
        needs: [],
        timeline: "ASAP",
        message: "",
    });

    const toggleNeed = (value) => {
        setForm((f) =>
            f.needs.includes(value)
                ? { ...f, needs: f.needs.filter((n) => n !== value) }
                : { ...f, needs: [...f.needs, value] }
        );
    };

    const onSubmit = async (e) => {
        e.preventDefault();

        try {
            const res = await fetch(GET_STARTED_HOOK, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    contact_name: form.contactName,
                    business_name: form.businessName,
                    email: form.email,
                    phone: form.phone,
                    website: form.website,
                    venue_type: form.venueType,
                    needs: form.needs.join(','),
                    timeline: form.timeline,
                    message: form.message,
                })
            });

            if (res.ok) {
                setShowModal(true);
                setForm({
                    businessName: "",
                    contactName: "",
                    email: "",
                    phone: "",
                    website: "",
                    venueType: "",
                    needs: [],
                    timeline: "ASAP",
                    message: "",
                });
            } else {
                alert("Something went wrong. Please try again.");
            }
        } catch (err) {
            alert("Something went wrong. Please try again.");
        }
    };



    return (
        <section className="lead-section">
            <div className="container">
                <div className="lead-head text-center">
                    <span className="eyebrow">Get Started</span>
                    <h1 className="results-title">Tell us about your business</h1>
                    <p className="results-sub">We’ll review your info and follow up with next steps.</p>
                </div>

                <form className="lead-card mx-auto" onSubmit={onSubmit}>
                    <div className="lead-grid">
                        <div className="field">
                            <label>Business name*</label>
                            <input required value={form.businessName} onChange={(e)=>setForm({...form, businessName:e.target.value})} />
                        </div>

                        <div className="field">
                            <label>Your name*</label>
                            <input required value={form.contactName} onChange={(e)=>setForm({...form, contactName:e.target.value})} />
                        </div>

                        <div className="field">
                            <label>Email*</label>
                            <input type="email" required value={form.email} onChange={(e)=>setForm({...form, email:e.target.value})} />
                        </div>

                        <div className="field">
                            <label>Phone</label>
                            <input value={form.phone} onChange={(e)=>setForm({...form, phone:e.target.value})} />
                        </div>

                        <div className="field">
                            <label>Current website</label>
                            <input placeholder="https://…" value={form.website} onChange={(e)=>setForm({...form, website:e.target.value})} />
                        </div>

                        <div className="field">
                            <label>Venue type</label>
                            <select value={form.venueType} onChange={(e)=>setForm({...form, venueType:e.target.value})}>
                                <option value="">Select…</option>
                                <option>Restaurant</option>
                                <option>Bar</option>
                                <option>Café</option>
                                <option>Bakery</option>
                                <option>Pop‑up</option>
                            </select>
                        </div>
                    </div>

                    <fieldset className="field mt-4">
                        <legend>How can we support your business?</legend>
                        <div className="needs">
                            {["New website", "Redesign", "Online ordering", "Reservations", "Menu management", "Brand refresh"].map((n) => (
                                <label key={n} className={`chip ${form.needs.includes(n) ? "chip--on" : ""}`}>
                                    <input type="checkbox" checked={form.needs.includes(n)} onChange={()=>toggleNeed(n)} />
                                    {n}
                                </label>
                            ))}
                        </div>
                    </fieldset>

                    <div className="field mt-3">
                        <label>Timeline</label>
                        <select value={form.timeline} onChange={(e)=>setForm({...form, timeline:e.target.value})}>
                            <option>ASAP</option>
                            <option>2–4 weeks</option>
                            <option>1–2 months</option>
                            <option>Flexible</option>
                        </select>
                    </div>

                    <div className="field mt-3">
                        <label>Tell us more about your business (optional)</label>
                        <textarea rows="4" value={form.message} onChange={(e)=>setForm({...form, message:e.target.value})} />
                    </div>

                    <div className="text-center mt-4">
                        <button className="btn btn-accent-primary" type="submit">Send</button>
                    </div>
                </form>
            </div>
            {showModal && (
                <div className="modal-backdrop">
                    <div className="modal-box">
                        <h2>Thanks for reaching out!</h2>
                        <p>We’ll be in touch shortly to get things rolling.</p>
                        <button className="btn btn-get-started mt-3" onClick={() => {
                            setShowModal(false);
                            navigate("/");
                        }}>
                            Close
                        </button>
                    </div>
                </div>
            )}

        </section>
    );
}
